import { render, staticRenderFns } from "./RemediationWidget.vue?vue&type=template&id=61cec09c&"
import script from "./RemediationWidget.vue?vue&type=script&lang=js&"
export * from "./RemediationWidget.vue?vue&type=script&lang=js&"
import style0 from "./RemediationWidget.vue?vue&type=style&index=0&id=61cec09c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports